import { cn } from '#components/utils.js'

export function Container({ as: Component = 'div', className, ...props }) {
  return (
    <Component
      className={cn(
        'mx-auto w-full max-w-7xl px-5 sm:px-8 lg:px-10',
        className,
      )}
      {...props}
    />
  )
}
